import { useTranslator } from '@/i18n'
import { computed } from 'vue'

export function useNumberFormatter(
    maximumFractionDigits = 2,
    minimumFractionDigits = 0
): (number: number) => string {
    const { locale } = useTranslator()

    const formatter = computed(
        () =>
            new Intl.NumberFormat(locale.value, {
                style: 'decimal',
                maximumFractionDigits,
                minimumFractionDigits,
            })
    )

    return (number: number): string => formatter.value.format(number)
}
